import HeaderTitleContext from "@jumbo/components/HeaderApp/HeaderAppContext";
import React from "react";

const useHeaderApp = () => {
    return React.useContext(HeaderTitleContext);
};

export default useHeaderApp;